// @ts-strict-ignore
import { DashboardCard } from "@dashboard/components/Card";
import ControlledSwitch from "@dashboard/components/ControlledSwitch";
import { Box, Text } from "@saleor/macaw-ui-next";
import React from "react";

import { useAnalyticsMode } from "./AnalyticsModeProvider";

export const AnalyticsModeSettingsCard: React.FC = () => {
  const { isLive, setMode } = useAnalyticsMode();

  return (
    <DashboardCard>
      <DashboardCard.Header>
        <DashboardCard.Title>Analytics Data Mode</DashboardCard.Title>
      </DashboardCard.Header>
      <DashboardCard.Content>
        <Box display="flex" flexDirection="column" gap={3}>
          <Text color="default2">
            Toggle between Live and Mock data for analytics. This affects the Analytics Dashboard across the app.
          </Text>
          <ControlledSwitch
            name="analyticsMode"
            checked={isLive}
            label={<Text>Live</Text>}
            uncheckedLabel={<Text>Mock</Text>}
            onChange={(e: any) => {
              const nextChecked = Boolean(e?.target?.value);

              setMode(nextChecked ? "live" : "mock");
            }}
          />
        </Box>
      </DashboardCard.Content>
    </DashboardCard>
  );
};

export default AnalyticsModeSettingsCard;
